import { Resource } from "../resource/resource.model";

export class Contact extends Resource {
    emailAddress: string;
    tenantId: string;
}

